import { IoLogoJavascript, IoLogoHtml5, IoLogoCss3, IoLogoReact, IoLogoNodejs } from "react-icons/io5";
import {
  SiRedux, SiAndroid, SiJava, SiDotnet, SiSpringboot, SiC, SiCsharp, SiDocker,
  SiCplusplus, SiBootstrap, SiMaterialui, SiMysql, SiRabbitmq, SiAzuredevops,
  SiAngular, SiReact, SiFirebase, SiMongodb, SiNextdotjs
} from "react-icons/si";
import { FaServer } from "react-icons/fa";
import { RiFlashlightLine, RiBarChart2Line } from "react-icons/ri";
import { GiCircuitry } from "react-icons/gi";
import { AiOutlineEye } from "react-icons/ai";
import { DiDotnet } from "react-icons/di";

export const skills = [
  { label: "HTML", icon: IoLogoHtml5 },
  { label: "CSS", icon: IoLogoCss3 },
  { label: "Bootstrap", icon: SiBootstrap },
  { label: "Material UI", icon: SiMaterialui },
  { label: "JavaScript", icon: IoLogoJavascript },
  { label: "React", icon: IoLogoReact },
  { label: "Redux", icon: SiRedux },
  { label: "React Native", icon: SiReact },
  { label: "Next.js", icon: SiNextdotjs },
  { label: "Node.js", icon: IoLogoNodejs },
  { label: "Angular", icon: SiAngular },
  { label: "Java", icon: SiJava },
  { label: "Spring Boot", icon: SiSpringboot },
  { label: "Android", icon: SiAndroid },
  { label: "C", icon: SiC },
  { label: "C++", icon: SiCplusplus },
  { label: "C#", icon: SiCsharp },
  { label: ".NET", icon: DiDotnet },
  { label: "ASP.NET", icon: SiDotnet },
  { label: "Entity Framework", icon: FaServer },
  { label: "Docker", icon: SiDocker },
  { label: "MySQL", icon: SiMysql },
  { label: "MongoDB", icon: SiMongodb },
  { label: "Firebase", icon: SiFirebase },
  { label: "RabbitMQ", icon: SiRabbitmq },
  { label: "Camunda BPMN", icon: GiCircuitry },
  { label: "Azure DevOps", icon: SiAzuredevops },
  { label: "Azure Functions", icon: RiFlashlightLine },
  { label: "Cosmos DB", icon: FaServer }, // ainda pode substituir por SVG se quiser
  { label: "App Insights", icon: RiBarChart2Line },
  { label: "Custom Vision", icon: AiOutlineEye },
];
